import SurveyService from '../services/survey'
import router from '../router'
import { itemConditionHelper, formatItemsForPost } from './helpers'
import itemTypes from './itemTypes'

/**
 * Survey transition directions,
 */
const directions = {
  NEXT: 'next',
  PREV: 'prev'
}

export default {
  namespaced: true,
  state: {
    itemTypes: itemTypes,
    survey_hash: null,
    loadingSurvey: false,
    submittingSurvey: false,
    survey: {},
    pages: [],
    currentPage: 0,
    submitEndpoint: null,
    submitMethod: null,
    directions: directions,
    currentDirection: directions.NEXT,
    responseId: null
  },
  getters: {
    loadingSurvey: state => state.loadingSurvey,
    submittingSurvey: state => state.submittingSurvey,
    survey: state => state.survey,
    surveyHash: state => state.survey_hash,
    pages: state => state.pages,
    shownPages: state => {
      return state.pages.filter(page => {
        return page.items.filter(item => item.show === true).length > 0
      })
    },
    currentPage: state => state.currentPage,
    pagePercent: (state, getters) => {
      let currentPageIndex = getters.shownPages.findIndex(page => page.id === state.currentPage)

      if (getters.shownPages.length === 0) {
        return 0
      }
      return Math.round(((currentPageIndex + 1) / getters.shownPages.length) * 100)
    },
    itemTypes: state => state.itemTypes,
    directions: state => state.directions,
    currentDirection: state => state.currentDirection
  },
  mutations: {
    SURVEY_UPDATED (state, survey) {
      state.survey = survey
    },
    RESPONSE_ID_UPDATED (state, responseId) {
      state.responseId = responseId
    },
    SURVEY_HASH_UPDATED (state, surveyHash) {
      state.survey_hash = surveyHash
    },
    CURRENT_PAGE_UPDATED (state, currentPage) {
      state.currentPage = currentPage
    },
    CURRENT_DIRECTION_UPDATED (state, currentDirection) {
      state.currentDirection = currentDirection
    },
    ITEM_UPDATED (state, item) {
      let allItems = state.pages.reduce((acc, page) => acc.concat(page.items), [])

      state.pages = state.pages.map(page => {
        if (page.id === item.survey_page_id) {
          let items = [
            ...page.items.filter(({ id }) => id !== item.id),
            item
          ]

          page.items = items.sort((a, b) => a.order - b.order)
        }

        page.items = [...itemConditionHelper(page.items, allItems)]
        return page
      })
    },
    PAGES_UPDATED (state, pages) {
      state.pages = pages
    },
    SURVEY_LOADING_UPDATED (state, loadingSurvey) {
      state.loadingSurvey = loadingSurvey
    },
    SURVEY_SUBMITTING_UPDATED (state, submittingSurvey) {
      state.submittingSurvey = submittingSurvey
    }
  },
  actions: {
    async init (context) {
      /*
      Set survey hash from route param...
       */
      let surveyHash = context.rootState.route.params.survey_hash

      if (!surveyHash) {
        return
      }

      context.commit('SURVEY_HASH_UPDATED', surveyHash)

      /*
      Load survey...
       */
      try {
        context.commit('SURVEY_LOADING_UPDATED', true)
        let survey = null
        if (navigator.onLine) {
          survey = await SurveyService.getSurvey(context.state.survey_hash)
        } else {
          survey = context.rootState.surveys.find(({ hash }) => hash === context.state.survey_hash).survey
        }

        context.commit('SURVEY_UPDATED', survey)
        context.commit('PAGES_UPDATED', survey.pages)
        context.commit('CURRENT_PAGE_UPDATED', survey.pages[0].id)
      } catch (error) {
        //
      } finally {
        context.commit('SURVEY_LOADING_UPDATED', false)
      }
    },
    async submitSurveyPage (context, pageId) {
      let page = context.state.pages.find(({ id }) => id === pageId)

      let data = {
        'answers': formatItemsForPost(page.items),
        'beneficiary_identifier': null
      }

      try {
        let response = await SurveyService.submitSurveyPage(context.state.survey_hash, data, context.state.responseId)
        context.commit('RESPONSE_ID_UPDATED', response.data.id)
      } catch (error) {
        // console.error(error)
      }
    },
    async submitSurvey (context) {
      let items = context.state.pages.reduce((acc, page) => acc.concat(page.items), [])

      let data = {
        'answers': formatItemsForPost(items),
        'beneficiary_identifier': null,
        'submitted': true
      }

      context.commit('SURVEY_SUBMITTING_UPDATED', true)

      try {
        await SurveyService.submitSurvey(context.state.survey_hash, data, context.state.responseId)

        router.push({ name: 'thank-you' })
        context.commit('CURRENT_PAGE_UPDATED', 0)
        context.commit('RESPONSE_ID_UPDATED', null)
      } catch (error) {
        // console.error(error)
      } finally {
        context.commit('SURVEY_SUBMITTING_UPDATED', false)
      }
    },
    getPendingSurveys () {
      let pendingSurveys = SurveyService.getPendingSurveys()
      return pendingSurveys
    }
  }
}

/**
 * Submit survey stored offline in local storage.
 */
window.addEventListener('online', () => SurveyService.submitFromStorage())
window.addEventListener('load', () => SurveyService.submitFromStorage())
